module.exports = __webpack_public_path__ + "static/easy-image-2-2-60f1c3b5381d975f4c062aff5e92db24.jpg";